import React from 'react';

import { Chip } from '@mui/material';

import { Order } from '@luxuryescapes/contract-svc-order';

import { titleCase } from '~/utils/stringUtils';

import { getOrderStatusConfig } from './orderStatus';

type Props = {
  orderStatus: Order.Order['status'] | string;
};

export function OrderStatusChip({ orderStatus }: Props) {
  const displayOrderStatus = titleCase(orderStatus.replace(/_/g, ' '));
  const statusConfig = getOrderStatusConfig(orderStatus);

  if (statusConfig) {
    return <Chip icon={<statusConfig.Icon />} color={statusConfig.chipColor} size="small" label={displayOrderStatus} />;
  }

  return <Chip size="small" label={displayOrderStatus} />;
}
